export default "__VITE_ASSET__BzYTJ$VN__"